// ADDED: Salary Advance Bracket Modal
import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { CheckInput, NumberInput } from "../../../../../common/Input";
import { EmployeeTypePickerSelect } from "../../../../../common/selectComponents/EmployeeTypePicker";

const SalaryAdvanceDeductionBracketAddEditModal = ({ isOpen, onClose, selectedItem, onSave }) => {
  const [form, setForm] = useState({
    employeeTypeId: "",
    employeeTypeDescription: "",
    minAmount: "",
    maxAmount: "",
    deductionAmount: "",
    bonusDeductionAmount: "",
    isActive: true,
  });

  useEffect(() => {
    if (selectedItem) {
      setForm({
        ...selectedItem,
      });
    } else {
      setForm({
        employeeTypeId: "",
        employeeTypeDescription: "",
        minAmount: "",
        maxAmount: "",
        deductionAmount: "",
        bonusDeductionAmount: "",
        isActive: true,
      });
    }
  }, [selectedItem, isOpen]);

  const handleInputChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
  };

  const handleEmployeeTypeChange = (type) => {
    setForm(prev => ({
      ...prev,
      employeeTypeId: type?.id || "",
      employeeTypeDescription: type?.description || ""
    }));
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[10000] bg-black/50 flex items-center justify-center p-3 overflow-auto" style={{ marginTop: 0 }} >
      <div className="bg-white w-full md:w-[500px] rounded-lg shadow-xl flex flex-col">
        <div className="flex justify-between items-center px-6 py-4 border-b">
          <h2 className="text-xl font-bold">{selectedItem ? "Edit" : "Add"} Bracket</h2>
          <button onClick={onClose} className="bg-transparent border-none cursor-pointer"><CloseIcon /></button>
        </div>

        <div className="p-6 space-y-4">
          <div className="space-y-1">
            <EmployeeTypePickerSelect
              label={"Employee Type"}
              value={form.employeeTypeId}
              onSelect={handleEmployeeTypeChange}
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <NumberInput
              label="Min Amount"
              value={form.minAmount}
              onChange={(e) => handleInputChange('minAmount', e.target.value)}
              placeholder="0.00"
            />
            <NumberInput
              label="Max Amount"
              value={form.maxAmount}
              onChange={(e) => handleInputChange('maxAmount', e.target.value)}
              placeholder="0.00"
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <NumberInput
              label="Deduction"
              value={form.deductionAmount}
              onChange={(e) => handleInputChange('deductionAmount', e.target.value)}
              placeholder="0.00"
            />
            <NumberInput
              label="Bonus Deduction"
              value={form.bonusDeductionAmount}
              onChange={(e) => handleInputChange('bonusDeductionAmount', e.target.value)}
              placeholder="0.00"
            />
          </div>

          <CheckInput
            name="Active"
            value={form.isActive}
            onChange={(val) => setForm({ ...form, isActive: val })}
            isEditMode={true}
          />
        </div>

        <div className="flex justify-end space-x-2 p-5 border-t">
          <button onClick={onClose} className="px-4 py-2 bg-gray-200 rounded border-none cursor-pointer">Cancel</button>
          <button
            disabled={!form.employeeTypeId}
            onClick={() => onSave(form)}
            className={`px-6 py-2 text-white rounded border-none cursor-pointer ${!form.employeeTypeId ? 'bg-gray-400' : 'bg-blue-600'}`}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default SalaryAdvanceDeductionBracketAddEditModal;